import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=a2db3f16&"
import script from "./Material.vue?vue&type=script&lang=ts&"
export * from "./Material.vue?vue&type=script&lang=ts&"
import style0 from "./Material.vue?vue&type=style&index=0&id=a2db3f16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports